import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'
import moment from 'moment'


const setFetching = (isFetching) => reducers.marketplace.cashierSchedulePage.setFetching(isFetching)

const fetchScheduleTickets = (scheduleId) => {
  return request.get(constants.marketplace.cashierScheduleTickets + `/${scheduleId}`)
    .then(({ data }) => data)
    .then((tickets) => reducers.marketplace.cashierSchedulePage.setScheduleTickets(tickets))
    .catch((error) => console.log(error))
}

const setScheduleTicket = (scheduleId) => {
  return request.post(constants.marketplace.cashierScheduleTickets + `/${scheduleId}`, {})
    .then(({ data }) => data)
}

const fetchSchedule = ({ year, month }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.generateSchedule + `/${year}/${month}/${tool}`)
    .then(({ data }) => data)
    .then((data) => data.map(({ day, sessions }) => ({
      day: moment(day, 'YYYY-MM-DD').format('DD.MM.YYYY'),
      sessions,
    })))
    .then((data) => reducers.marketplace.cashierSchedulePage.updateSchedule(data))
    .catch((error) => console.log(error))
}

const resetSchedule = () => reducers.marketplace.cashierSchedulePage.resetSchedule()

const increaseQuota = ({ scheduleId }) => {
  return request.put(constants.marketplace.setQuotaAndDescription + `/${scheduleId}`, {})
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

export default {
  setFetching,
  resetSchedule,
  fetchSchedule,
  fetchScheduleTickets,
  setScheduleTicket,
  increaseQuota,
}
